export const convertArrayToObject = (array, key) => array.reduce(
  (obj, item) => ({
    ...obj,
    [item[key]]: item,
  }),
  {},
);

export const copyObject = (obj) => (JSON.parse(JSON.stringify(obj)));
